import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
var _ON_ACTION_TYPE_VS_IN;
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { compose } from 'recompose';
import _map from 'lodash/map';
import _isEmpty from 'lodash/isEmpty';
import _throttle from 'lodash/throttle';
import { EMPTY_ARRAY, EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
import { validate as ruleValidator } from '@tekion/tekion-base/utils/ruleValidator';
import Section from './components/section';
import withGetters from './hoc/withGetters';
import withProcessedSections from './hoc/withProcessedSections';
import withFieldValidator from './hoc/withFieldValidator';
import withFormKeyboardShortcuts from './hoc/withFormKeyboardShortcutsWrapper';
import { getFormErrors } from './utils/general';
import styles from './formBuilder.module.scss';
import './fieldRenderers/fieldRenderer.scss';
import actionTypes from './constants/actionTypes';
var handleErrors = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(errorPromiseByFieldId, _ref) {
    var onAction, prevErrors, field, errors;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          onAction = _ref.onAction, prevErrors = _ref.prevErrors, field = _ref.field;
          if (!_isEmpty(errorPromiseByFieldId)) {
            _context.next = 3;
            break;
          }
          return _context.abrupt("return");
        case 3:
          onAction({
            type: actionTypes.VALIDATION_IN_PROGRESS,
            payload: {
              errorPromiseByFieldId: errorPromiseByFieldId
            }
          });
          _context.next = 6;
          return getFormErrors(errorPromiseByFieldId, prevErrors);
        case 6:
          errors = _context.sent;
          onAction({
            type: actionTypes.VALIDATION_SUCCESS,
            payload: {
              errors: errors,
              field: field
            }
          });
        case 8:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function handleErrors(_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}();
var handleThrottledError = _throttle(handleErrors, 200);
var validateChangedFields = function validateChangedFields(_ref3) {
  var shouldBubbleAction = _ref3.shouldBubbleAction;
  return function (_ref4) {
    var action = _ref4.action,
      rules = _ref4.rules,
      allValues = _ref4.values,
      onAction = _ref4.onAction,
      errors = _ref4.errors,
      shouldAvoidFieldValidation = _ref4.shouldAvoidFieldValidation,
      shouldThrottleValidation = _ref4.shouldThrottleValidation;
    var _action$payload = action.payload,
      id = _action$payload.id,
      value = _action$payload.value,
      additional = _action$payload.additional;
    var extraAdditionalProps = _objectSpread(_objectSpread({}, additional), {}, {
      prevErrors: errors
    });
    if (!shouldAvoidFieldValidation) {
      var promiseByFieldId = ruleValidator(_defineProperty({}, id, value), allValues, rules, {
        shouldValidatedOnValues: true,
        additional: extraAdditionalProps
      });
      var errorFuncToExec = shouldThrottleValidation ? handleThrottledError : handleErrors;
      errorFuncToExec(promiseByFieldId, {
        onAction: onAction,
        prevErrors: errors,
        field: {
          id: id,
          value: value
        }
      });
    }
    if (!shouldBubbleAction) return;
    onAction(action);
  };
};
var ON_ACTION_TYPE_VS_INTERCEPTOR = (_ON_ACTION_TYPE_VS_IN = {}, _defineProperty(_ON_ACTION_TYPE_VS_IN, actionTypes.ON_FIELD_CHANGE, validateChangedFields({
  shouldBubbleAction: true
})), _defineProperty(_ON_ACTION_TYPE_VS_IN, actionTypes.VALIDATE_FIELD, validateChangedFields({
  shouldBubbleAction: false
})), _ON_ACTION_TYPE_VS_IN);
var Form = /*#__PURE__*/function (_PureComponent) {
  _inherits(Form, _PureComponent);
  var _super = _createSuper(Form);
  function Form() {
    var _this;
    _classCallCheck(this, Form);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "handleAction", function (action) {
      var _assertThisInitialize = _assertThisInitialized(_this),
        props = _assertThisInitialize.props;
      var funcToExec = ON_ACTION_TYPE_VS_INTERCEPTOR[action.type];
      if (!funcToExec) return props.onAction(action);
      return funcToExec(_objectSpread(_objectSpread({}, props), {}, {
        action: action
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "renderSection", function (section, sectionIndex) {
      var _assertThisInitialize2 = _assertThisInitialized(_this),
        props = _assertThisInitialize2.props;
      return /*#__PURE__*/React.createElement(Section, {
        section: section,
        id: sectionIndex,
        key: sectionIndex,
        rows: section.rows,
        fields: props.fieldsGetters[sectionIndex](props.fields),
        errors: props.errorsGetters[sectionIndex](props.errors),
        warnings: props.warningsGetters[sectionIndex](props.warnings),
        values: props.valuesGetters[sectionIndex](props.values),
        onAction: _this.handleAction
      });
    });
    return _this;
  }
  _createClass(Form, [{
    key: "render",
    value: function render() {
      var props = this.props;
      return /*#__PURE__*/React.createElement("div", {
        id: props.id,
        className: cx(styles.container, props.className),
        style: props.style,
        ref: props.innerRef
      }, _map(props.sections, this.renderSection));
    }
  }]);
  return Form;
}(PureComponent);
Form.displayName = 'FormBuilder';
var FormBuilder = compose(withProcessedSections, withFieldValidator, withGetters('sections'), withFormKeyboardShortcuts)(Form);
FormBuilder.propTypes = {
  sections: PropTypes.array,
  fields: PropTypes.object,
  values: PropTypes.object,
  warnings: PropTypes.object,
  errors: PropTypes.object,
  className: PropTypes.string,
  shouldAvoidFieldValidation: PropTypes.bool,
  useKeyBoardShortcuts: PropTypes.bool,
  innerRef: PropTypes.object,
  shouldThrottleValidation: PropTypes.bool
};
FormBuilder.defaultProps = {
  sections: EMPTY_ARRAY,
  fields: EMPTY_OBJECT,
  values: EMPTY_OBJECT,
  warnings: EMPTY_OBJECT,
  errors: EMPTY_OBJECT,
  className: '',
  shouldAvoidFieldValidation: false,
  useKeyBoardShortcuts: false,
  innerRef: null,
  shouldThrottleValidation: true
};
export { actionTypes };
export default FormBuilder;